module.exports = __webpack_public_path__ + "fc57c97e.png";